import React from 'react';
//import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch
//  withRouter
} from 'react-router-dom';
import {routes} from './routes';

/**
 * Routes 组件
 */
export default () => (
  <Router>
    <Switch>
    {routes.map((route, i) => ( 
        <Route key={i} exact path={route.path} render={ props => ( 
          <route.component {...props} routes={route.routes} /> 
        )}/>
    ))}
    </Switch>
  </Router>
);



// WEBPACK FOOTER //
// ./usr/lib/ui/src/routes/index.js